<template>
  <aside class="f-col side" v-if="display">
    <Menu />
  </aside>
</template>

<script>
import Menu from "../menu/Menu.vue";

export default {
  name: "Side",
  components: {
    Menu
  },
  computed: {
    display() {
      return this.$store.state.menu.display;
    }
  }
};
</script>

<style scoped>
.side {
  justify-content: flex-start;
  height: 100%;
  width: 280px;
  color: #f1f1f1;
  background-color: #2e3e4e;
  border-right: 1px solid #ddd;
}
</style>